import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/site/Reveal";
import { ABOUT } from "@/data/pageCopy";


const { kicker, h1Lines, lead, mission, beliefs, stats, cta } = ABOUT;
const values = beliefs.values;

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="relative pt-32 md:pt-40 pb-20 overflow-hidden">
        <div className="pointer-events-none absolute inset-0 opacity-[0.05]" style={{
          backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }} />
        <div className="relative mx-auto max-w-[1400px] px-6 md:px-12">
          <Reveal><p className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#5B8CFF] mb-5">{kicker}</p></Reveal>
          <h1 className="font-heading font-medium tracking-tight leading-[0.98] text-4xl md:text-6xl lg:text-7xl text-white max-w-4xl">
            <MaskedLines lines={h1Lines} delay={0.1} />
          </h1>
          <Reveal delay={0.4}>
            <p className="mt-8 text-lg text-neutral-400 max-w-2xl leading-relaxed">
              {lead}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 grid lg:grid-cols-2 gap-14 items-start">
          <Reveal>
            <h2 className="font-heading font-medium tracking-tight text-3xl md:text-4xl text-white">{mission.h2}</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="space-y-5 text-neutral-400 leading-relaxed">
              {mission.paras.map((t) => (
                <p key={t}>{t}</p>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-20 border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12">
          <Reveal><h2 className="font-heading font-medium tracking-tight text-3xl md:text-4xl text-white mb-10">{beliefs.h2}</h2></Reveal>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {values.map((v, i) => (
              <Reveal key={v.t} delay={(i % 4) * 0.06}>
                <div className="h-full bg-white/[0.02] p-7 hover:bg-white/[0.05] transition-colors min-h-[210px]">
                  <v.icon className="text-white" size={26} />
                  <h3 className="mt-5 font-heading font-semibold text-lg text-white">{v.t}</h3>
                  <p className="mt-2 text-neutral-500 text-sm leading-relaxed">{v.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#0a0a0a] text-white">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {stats.map((s) => (
            <div key={s.v} className="bg-[#0a0a0a] p-8">
              <p className="font-heading font-medium text-4xl md:text-5xl tracking-tight">{s.k}</p>
              <p className="mt-3 text-neutral-400 text-sm">{s.v}</p>
            </div>
          ))}
        </div>
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 mt-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <h2 className="font-heading font-medium tracking-tight text-2xl md:text-3xl max-w-lg">{cta}</h2>
          <Link to="/demo" className="group inline-flex items-center gap-2 bg-white text-black font-bold px-7 py-4 hover:bg-neutral-200 transition-colors shrink-0">
            Book a demo <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </Link>
        </div>
      </section>
    </div>
  );
}
